import React from 'react';
export function StickyCTA() {
  return <div className="fixed top-0 left-0 right-0 z-[999] bg-teal flex items-center justify-center gap-5 py-3 px-5 shadow-[0_2px_12px_rgba(0,0,0,0.15)] max-[500px]:flex-col max-[500px]:gap-2 max-[500px]:py-2.5 max-[500px]:px-4" data-id="element-35">
      <span className="font-inter text-[14px] font-medium text-white tracking-[0.01em] max-[500px]:text-[13px] max-[500px]:text-center" data-id="element-36">
        🎁 Limited Time: Save 20% Today on Lumé Vitality
      </span>
      <a href="https://trylumevitality.com/products/lumevitality" className="inline-block bg-white text-teal no-underline py-2 px-[22px] font-inter text-[13px] font-semibold tracking-[0.03em] rounded-[3px] whitespace-nowrap transition-colors duration-200 hover:bg-teal-light" data-id="element-37">
        Claim Offer →
      </a>
    </div>;
}